import History from '~/editor/history/history'

const history = new History

export {
  history
}